export const wrapWithTimeoutLimit = <T>(timeout: number, func: () => Promise<T>) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    window.setTimeout(reject, timeout);
    const result = await func();
    resolve(result);
  });
};
